module.exports = __webpack_public_path__ + "img/imgs-item-4.e30bace6.png";